import React, { useEffect, useState } from "react";
import UserText from "../Assistant/UserText";
import Assistant from "../Assistant/Assistant";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
} from "../../../../utils/common-utils";
import { Box } from "@chakra-ui/react";
import { useRoot } from "../../../../context/RootContext";
import SummaryLine from "../../../atoms/BubblesLoader/SummaryLine";
import { ChatViewStyles } from "./ChatViewStyles";
import AudioPlayer from "../AudioPlayer";
import { useAudio } from "../../../../context/AudioContext";
import pkg from "@inrscr/coschool-ui-components";
import { renderTextHighlight } from "../../../../utils/TutorConstants";
import AssistantImg from "../../../../assets/ai-tutor/assistant.svg";
import CorrectAnsImg from "../../../../assets/ai-tutor/correct_answer.svg";
export default function ChatView({
  history,
  isDisplayUserQuery = true,
  assistantRefImages = [],
  isDescAnsQues = false,
  isComprehension = false,
}) {
  const { selectedIndex } = useRoot();
  const { hilightedText, playingIndex: currentAudioIndex } = useAudio();
  const { DescriptiveAnswer: DescriptiveAnswerUI, TutorAssistant: AITutorAssistant } = pkg;
  return (
    <React.Fragment>
      <Box
        sx={
          selectedIndex === 2
            ? ChatViewStyles()?.doubtSubContainer
            : isComprehension
            ? ChatViewStyles()?.comprehensionSubContainer
            : ChatViewStyles()?.mainContainer
        }
      >
        {history?.map((item, index) => {
          let showUserQuery = index % 2 === 0 && !isEmptyOrNull(item?.content);
          if (isDisplayUserQuery === false && isDescAnsQues === false) {
            showUserQuery = showUserQuery && index !== 0;
          }
          let chatIndex, playingIndex, chatID;
          if (index % 2 !== 0) {
            chatIndex = Math.floor(index / 2) + 1;
            playingIndex = `${item?.chatID}-${chatIndex}`;
            chatID = item?.chatID
          }

          return (
            <div key={index}>
              {index === 0 && isNotEmptyOrNull(item?.descriptive_answer) ? (
                <DescriptiveAnswerUI
                  loader={false}
                  icons={{
                    AssistantImg: AssistantImg,
                    CorrectAnsImg: CorrectAnsImg,
                  }}
                  user_query={item?.content}
                  assistantObj={item}
                />
              ) : (
                <React.Fragment>
                  {showUserQuery && (
                    <Box
                      sx={
                        selectedIndex === 2
                          ? ChatViewStyles()?.doubtUserContainer
                          : ChatViewStyles()?.practiceUserContainer
                      }
                    >
                      {item?.is_user_concluded ? (
                        <SummaryLine />
                      ) : (
                      <UserText text={item?.content} />
                      )}
                    </Box>
                  )}
                  {index % 2 !== 0 &&
                    item?.content?.trim() !== "" &&
                    isEmptyOrNull(history[index - 1]?.descriptive_answer) && (
                      <Box
                        sx={
                          selectedIndex === 2
                            ? ChatViewStyles()?.doubtAssistantContainer
                            : ChatViewStyles()?.practiceAssistantContainer
                        }
                      >
                        {item?.isConcluded && <SummaryLine />}
                        <AITutorAssistant
                          text={renderTextHighlight(
                            playingIndex,
                            currentAudioIndex,
                            item?.content,
                            hilightedText
                          )}
                          assistantRefImages={assistantRefImages}
                          hideVin={true}
                          loader={false}
                          showAllRefImages={item?.showAllRefImages || false}
                          audioPlayer={
                            window?.ENV?.ENABLE_VOICE === "true"
                              ? () => (
                                <AudioPlayer
                                  text={item?.content}
                                  index={playingIndex}
                                  chatID={chatID}
                                  chatIndex={chatIndex - 1}
                                  isCorrect={item?.isCorrect}
                                  questionId={item?.questionID}
                                />
                              )
                              : undefined
                          }
                        />
                      </Box>
                    )}
                </React.Fragment>
              )}
            </div>
          );
        })}
      </Box>
    </React.Fragment>
  );
}
